import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import Link from "next/link";

export function ErrorCard({
  headerText,
  mustBeLoggedIn = true,
  additionalInfo,
  children,
}: {
  headerText: string;
  mustBeLoggedIn?: boolean;
  additionalInfo?: {
    os: string | undefined;
    browser: string | undefined;
    userEmail?: string | undefined;
  };
  children?: React.ReactNode;
}) {
  return (
    <div className="flex w-full grow justify-center items-center h-[calc(100vh-100px)]">
      <Card className="w-1/5 text-center border-2 min-w-[300px] my-2">
        <CardHeader>
          <CardTitle>{headerText}</CardTitle>
          {mustBeLoggedIn && (
            <CardDescription className="text-xs">
              {additionalInfo?.userEmail ? (
                <>
                  Logged in as{" "}
                  <span className="font-bold">{additionalInfo.userEmail}</span>
                </>
              ) : (
                <>
                  You must be logged in to view this page. Please{" "}
                  <Link href="/auth">login</Link>.
                </>
              )}
            </CardDescription>
          )}
        </CardHeader>
        <CardContent className="mb-4">{children}</CardContent>
        <div className="mb-2">
          <p className="text-xs opacity-20">
            Browser Time: {new Date().toISOString()}
          </p>
          {additionalInfo?.browser && (
            <p className="text-xs opacity-20">
              Browser: {additionalInfo.browser}
            </p>
          )}
          {additionalInfo?.os && (
            <p className="text-xs opacity-20">OS: {additionalInfo.os}</p>
          )}
        </div>
      </Card>
    </div>
  );
}
